import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import brand1 from '../../../assets/images/brand1.png'
import brand2 from '../../../assets/images/brand2.png'
import brand5 from '../../../assets/images/brand5.png'
import brand6 from '../../../assets/images/brand6.png'
import cargroup from '../../../assets/images/car-group.png'

export default function FindCars() {
  // Use public folder paths directly (served from /assets/images/...)
  const cruiseDeals = [
    { img: brand1, alt: "Brand 1" },
    { img: brand2, alt: "Brand 2" },
    { img: brand5, alt: "Brand 5" },
    { img: brand6, alt: "Brand 6" },
  ];

  return (
    <section className="section-equal-padding bg-white pt-0">
      <div className="container-fluid">
        <div className="company-logo-container">
          <div className="row">
            <div className="col-12">
              <div
                className="section-top-heading mb-3"
                uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
              >
                <h2 className="mb-2 text-black text-md-center text-left">
                  Rent With Companies You Know <br /> and Trust
                </h2>
              </div>
            </div>
          </div>

          <div className="company-slider owl-nav-both">
            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={20}
              loop={true}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              navigation={true}
              breakpoints={{
                0: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
                1400: { slidesPerView: 4 },
              }}
              className="company-carousel pb-70"
              uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
            >
              {cruiseDeals.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="card-item">
                    <img
                      src={item.img}
                      alt={item.alt}
                      className="img-fluid"
                      loading="lazy"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="car-group pt-5">
            <img
              src={cargroup}
              alt="Car group"
              className="img-fluid"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
